import { createModel } from "hox";
import React, { useState } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { EditModeType, IPgProps, ISearchPage } from "@src/types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { message } from "antd";
import { IMdMarketingTypeDetail, IMdMarketingTypeFields } from "./allMemberMarketingTypeTypes";
import { allMemberMarketingTypeService } from "./allMemberMarketingTypeService";
import { ISelectOption } from "@src/components/YhFormBox/Types";
import { dictService } from "../../base/dict/DictService";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}


function useModel() {

    const initSearchParam: IMdMarketingTypeFields = {};
    const initDataSource: IMdMarketingTypeDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdMarketingTypeFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdMarketingTypeDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //表格选中行数据
    const [selectedRow, setSelectedRow] = useState<IMdMarketingTypeDetail>({} as IMdMarketingTypeDetail);
    //编辑类型
    const [editType, setEditType] = useState<EditModeType>();
    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const [resetState, setResetState] = useState(false)

    const [marketingTypeDs, setMarketingTypeDs] = useState<ISelectOption[]>()

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setResetState(!resetState)
    }

    /**
     * 加载选择项
     */
    const loadDs = async () => {
        try {
            await dictService.oneTreeDs({ code: "marketingType" })
            let marketingTypeDs = await dictService.dictItemDs('marketingType')
            setMarketingTypeDs(marketingTypeDs)
        } catch (error) {
            console.error("加载营销类型字典数据失败:", error)
            message.error("加载营销类型字典数据失败")
        }
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdMarketingTypeFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? filters[0] : null;
    };
    const loadData = async (page?: ISearchPage, searchValue: IMdMarketingTypeFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await allMemberMarketingTypeService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        resetState,
        marketingTypeDs,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        getSelectedRowData,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        onSearch,
        onReset,
        loadDs,
        setSelectedRow,
        setEditType,
        editType,
        selectedRow,
    }

}


export const useMarketingTypeModel = createModel(useModel);
